/**
 * Compares two Date objects and returns a number indicating their relative order.
 *
 * The comparison is performed in the following order:
 * 1. Year
 * 2. Month
 * 3. Day
 *
 * @param date1 - The first date to compare.
 * @param date2 - The second date to compare.
 * @returns A negative number if `date1` is earlier than `date2`,
 *          a positive number if `date1` is later than `date2`,
 *          or 0 if they are equal.
 */
export const compareDates = (date1: Date, date2: Date) => date1.getFullYear() - date2.getFullYear() || date1.getMonth() - date2.getMonth() || date1.getDate() - date2.getDate()
